import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MarkdownModule } from 'ngx-markdown';

@Component({
    selector: 'app-citation',
    imports: [MarkdownModule],
    templateUrl: './citation.component.html',
    styleUrl: './citation.component.scss'
})
export class CitationComponent {
  @Input() content!: any;
  contents!: string;
  title!: string;
  citations_head!:string;

  ngOnChanges(changes: SimpleChanges): void {    if (changes['content'] && changes['content'].currentValue) {
      this.contents = this.decodeHtmlEntities(this.content.content);
      this.title = this.content.title;
      this.citations_head = this.content.citation;
    }
  }

  private decodeHtmlEntities(text: string): string {
    if (!text) return "";
    if (!text.includes("&")) return text;

    let decoded = text;
    let prev;
    let iterations = 0;

    const entities: { [key: string]: string } = {
      "amp": "&",
      "lt": "<",
      "gt": ">",
      "quot": "\"",
      "apos": "'",
      "#39": "'",
      "#x27": "'",
      "#x2F": "/",
      "#47": "/",
      "#60": "<",
      "#62": ">"
    };

    const decodeOnePass = (str: string): string => {
      return str.replace(/&([^;]+);/g, (match, entity) => {
        if (entities[entity]) {
          return entities[entity];
        }
        if (entity.startsWith("#")) {
          const code = entity.startsWith("#x")
            ? parseInt(entity.substring(2), 16)
            : parseInt(entity.substring(1), 10);
          if (!isNaN(code)) {
            return String.fromCharCode(code);
          }
        }
        return match;
      });
    };

    do {
      prev = decoded;
      decoded = decodeOnePass(decoded);
      iterations++;
    } while (decoded !== prev && iterations < 5);

    return decoded;
  }
}
